import React, { useContext } from "react";
import { LangCtx } from "../../../lib/context";
import "../licenseManagement/styles.css";
// import "../../ui-styles/payment/payment.css";
import "../../../ui-styles/payment/payment.css";

const Nolicense = () => {
    const { l } = useContext(LangCtx);

    // const handleBuyLicense = () => {
    //     history.push("/place-your-order/INVCCCP/5");
    // };
    return (
        // <div>
        <div className="licencesCntr">
            <div className="flexCol innerLicences boxShadow pdngMD brdrRadius">
                <span className="mainHdngTxt pdngBSM">{l.licence_expired}</span>
                <span className="fontTxtMD pdngBSM">{l.ur_license_was_expired}.</span>
                <span className="fontTxtMD pdngBSM">{l.plz_contact_ur_administrator}</span>
                {/* <div className="flexRow  jcFE"> */}
                {/* <div className="brdrRadius primary pdngSM">
                        <Button fullWidth variant="contained" color="primary" disableElevation size="small" onClick={handleBuyLicense}>
                        {l.buy_license}
                        </Button>
                    </div> */}
                {/* <a href="https://www.invc.vc/pricing" target="_blank" className="brdrRadius primary pdngSM">
                    {l.buy_license}
                </a> */}
                {/* <a href="https://website.invc.in/plans-pricing-invcpro" target="_blank" className="linkFilledBtn primary Sm noMrgn">Purchase a licesne now</a> */}
                {/* </div> */}
            </div>
        </div>
        // </div>
    );
};

export default Nolicense;
